<template>
    <vs-row class="w-full flex justify-center">
        <vs-col class="vs-pagination--mb flex justify-center w-full">
            <div
                :style="stylePagination"
                :class="[`vs-pagination-${color}`]"
                class="con-vs-pagination"
            >
                <nav class="vs-pagination--nav">
                    <button
                        :class="{ disabled: currentPage <= 1 ? 'disabled' : null }"
                        :disabled="currentPage === 1"
                        class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
                        @click="prevPage"
                    >
                        <vx-basic-icon
                            :icon-pack="iconPack"
                            :icon="prevIcon ? prevIcon : defaultPrevIcon"
                        />
                    </button>
                    <ul class="vs-pagination--ul">
                        <li
                            v-for="(page, index) in pages"
                            :key="index"
                            :class="[{ 'is-current': page == currentPage }, getMarginClass(page)]"
                            class="item-pagination vs-pagination--li"
                            @click="goTo(page)"
                        >
                            <span>
                                {{ page }}
                            </span>

                            <div class="effect" />
                        </li>
                    </ul>
                    <button
                        :class="{ disabled: currentPage === totalPages ? 'disabled' : null }"
                        :disabled="currentPage === totalPages"
                        class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next"
                        @click="nextPage"
                    >
                        <vx-basic-icon
                            :icon-pack="iconPack"
                            :icon="nextIcon ? nextIcon : defaultNextIcon"
                        />
                    </button>
                </nav>
            </div>
        </vs-col>
    </vs-row>
</template>

<script>
import _color from '@/assets/utils/color.js'

export default {
    name: 'VxPagination',
    props: {
        color: {
            type: String,
            default: 'primary'
        },
        totalPages: {
            type: Number,
            required: true
        },
        value: {
            type: Number,
            required: true,
            default: 1
        },
        max: {
            type: Number,
            default: 9
        },
        prevIcon: {
            type: String
        },
        nextIcon: {
            type: String
        },
        iconPack: {
            type: String,
            default: 'material-icons'
        }
    },
    watch: {
        currentPage(val) {
            this.getPages()
            this.$emit('input', this.currentPage)
            this.$emit('change', this.currentPage)
        },
        totalPages() {
            this.getPages()
        },
        max() {
            this.getPages()
        },
        value(val) {
            const pageNum = val < 1 ? 1 : val <= this.totalPages ? val : this.totalPages
            this.goTo(pageNum)
        }
    },
    data: () => ({
        pages: [],
        currentPage: 0,
        go: 0,
        prevRange: '',
        nextRange: '',
        hoverBtn1: false
    }),
    computed: {
        defaultNextIcon() {
            if (this.$vs.rtl) return 'ChevronLeftIcon'
            return 'ChevronRightIcon'
        },
        defaultPrevIcon() {
            if (this.$vs.rtl) return 'ChevronRightIcon'
            return 'ChevronLeftIcon'
        },
        stylePagination() {
            let style = {}
            if (!_color.isColor(this.color)) {
                style = {
                    '--vs-color-pagination': _color.getColor(this.color),
                    '--vs-color-pagination-alpha': _color.getColor(this.color, 0.5)
                }
            }
            return style
        }
    },
    methods: {
        getMarginClass(page) {
            if (typeof page === 'number') {
                var length = page.getLength()
                var m = length - 2
                return `mx-${m}`
            }
            return ''
        },
        async changeRowMaxItems(index) {
            await this.$emit('changeMaxItems', index)
            this.currentPage = 1
        },
        isEllipsis(page) {
            return page === '...'
        },
        goTo(page) {
            if (page === '...') {
                return
            }
            if (typeof page.target === 'undefined') {
                this.currentPage = page
            } else {
                const value = parseInt(page.target.value, 10)
                this.go = value < 1 ? 1 : value <= this.totalPages ? value : this.totalPages
                this.currentPage = this.go
            }
        },
        getPages() {
            if (this.totalPages <= this.max) {
                let pages = this.setPages(1, this.totalPages)
                this.pages = pages
            }

            const even = this.max % 2 === 0 ? 1 : 0
            if (this.totalPages < 6) {
                this.prevRange = Math.floor(this.max / (this.max / 2))
            } else {
                this.prevRange = Math.floor(this.max / 2)
            }
            this.nextRange = this.totalPages - this.prevRange + 1 + even
            if (this.totalPages < 6) {
                this.pages = [...this.setPages(1, this.totalPages)]
            } else if (this.currentPage >= this.prevRange && this.currentPage <= this.nextRange) {
                const start = this.currentPage - this.prevRange + 2
                const end = this.currentPage + this.prevRange - 2 - even
                if (this.totalPages <= 3) {
                    this.pages = [1, ...this.setPages(start, end), this.totalPages]
                } else {
                    this.pages = [1, '...', ...this.setPages(start, end), '...', this.totalPages]
                }
            } else {
                this.pages = [
                    ...this.setPages(1, this.prevRange),
                    '...',
                    ...this.setPages(this.nextRange, this.totalPages)
                ]
            }
        },
        setPages(start, end) {
            const setPages = []
            for (start > 0 ? start : 1; start <= end; start++) {
                setPages.push(start)
            }
            return setPages
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--
            }
        }
    },
    async mounted() {
        this.currentPage = this.go = this.value
        this.getPages()
    }
}
</script>

<style scoped>
/* .vs-pagination--li {
    margin
} */
</style>
